import { useAppStore } from '~/stores/app/appStore';
import { PageResolverType } from '~/stores/app/types';
import { useCategoryStore } from '~/stores/category/categoryStore';

export default defineNuxtRouteMiddleware(async (to) => {
  const appStore = useAppStore();
  const categoryStore = useCategoryStore();

  const slugs = ((to.params?.slug ?? []) as string[]).filter((slug) => slug);
  const pathParts = to.path.split('/').filter((part) => part && !slugs.includes(part));

  const locale = (pathParts[0] || DEFAULT_LOCALE) as Locale;
  let lastSlug = slugs[slugs.length - 1];

  if (!lastSlug) lastSlug = HOME_PAGE_SLUG;

  const result = await appStore.fetchPageType(lastSlug, locale);

  if (result && lastSlug !== result.data.slug) {
    let canonicalPath = '';

    if (result.type === PageResolverType.CMS) {
      canonicalPath = `/${result.data.slug}`;
    } else if (result.type === PageResolverType.CATEGORY) {
      const newUrl = slugs.map((slug) => {
        const category = categoryStore.getCategoryBySlug(slug);
        return category?.slug[locale] ?? slug;
      });

      canonicalPath = `/${newUrl.join('/')}`;
    } else if (result.type === PageResolverType.PRODUCT) {
      const categorySlugs = slugs.slice(0, -1).map((slug) => {
        const category = categoryStore.getCategoryBySlug(slug);
        return category?.slug[locale] ?? slug;
      });

      if (categorySlugs.length) canonicalPath = `/${categorySlugs.join('/')}/${result.data.slug}`;
      else canonicalPath = `/${result.data.slug}`;
    }

    if (canonicalPath) {
      const cleanPath = canonicalPath.replace(/^\/([a-z]{2}-[A-Z]{2})/, '');
      const fullCanonicalPath = `${pathParts[0] ? `/${locale}` : ''}${cleanPath}`;

      if (fullCanonicalPath !== to.path)
        return navigateTo(fullCanonicalPath, {
          redirectCode: 301,
          replace: true,
        });
    }
  }
});
